import { inject, Injectable } from '@angular/core';
import {
  MhsIdentityApiClient,
  UserCreateRequest,
  UserUpdateRequest,
} from '../../../core/api/mhsIdentityApiClient';
import { AuthStore } from '../../../core/authentication/authStore';
import { toSignal } from '@angular/core/rxjs-interop';
import { UsertStore } from '../../../core/context/userStore';
import { EMPTY, Observable, switchMap, take, pipe, filter } from 'rxjs';

import {
  UserHeaderRowItemSearchResult,
  LoginIdetityUserDetails,
} from '../../../core/api/mhsIdentityApiClient';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  apiClient = inject(MhsIdentityApiClient);
  authStore = inject(AuthStore);
  userStore = inject(UsertStore);
  resetPassword(userId: number): Observable<string> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }

    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.apiClient.user_ResetPassword(userId);
      }),
    );
  }
  activate(userId: number): Observable<void> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.apiClient.user_EnableUser(userId);
      }),
    );
  }
  deactivate(userId: number): Observable<void> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.apiClient.user_DisableUser(userId);
      }),
    );
  }
  create(user: UserCreateRequest): Observable<LoginIdetityUserDetails> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.apiClient.user_CreateUser(user);
      }),
    );
  }

  update(user: UserUpdateRequest): Observable<LoginIdetityUserDetails> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }

    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.apiClient.user_UpdateUser(user) as Observable<LoginIdetityUserDetails>;
      }),
    );
  }

  get(userId: number): Observable<LoginIdetityUserDetails> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        const tenantName = tenant?.tenantName;
        return this.apiClient.user_GetUser(userId);
      }),
    );
  }
  search(
    pageIndex: number,
    pageSize: number,
    phrase: string,
    isActive?: boolean,
    orderBy?: string,
    isOrderByAsc?: boolean,
  ): Observable<UserHeaderRowItemSearchResult> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }
    return this.userStore.currentTenant$.pipe(
      filter((tenant) => tenant !== null),
      take(1),
      switchMap((tenant) => {
        if (!tenant) {
          return EMPTY;
        }

        const tenantName = tenant.tenantName;
        const isActiveFilter = isActive !== null ? isActive!.toString() : undefined;

        return this.apiClient.user_Search(
          phrase,
          undefined,
          isActiveFilter,
          pageIndex,
          pageSize,
          orderBy,
          isOrderByAsc ?? false,
        );
      }),
    );
  }
  //   const tenantName = this.userStore.currentTenant()?.tenantName;
  //   const isActiveFilter = isActive !== null ? isActive!.toString() : undefined;

  //   return this.apiClient.user_Search(
  //     phrase,
  //     undefined,
  //     isActiveFilter,
  //     pageIndex,
  //     pageSize,
  //     orderBy,
  //     isOrderByAsc ?? false,
  //   );
  // }
  //userViewPort = toSignal(this.apiClient.user_Search(null,null,1,10,null,null,'',null,null,null,null), { initialValue: null });
}
